// extracted by mini-css-extract-plugin
export default {"root":"MyApplications_root__qBNhp"};